import { IAuthData, IAuthRes } from 'types'

import { baseApi } from './baseApi'

export const authAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    POST_authLogin: builder.mutation<IAuthRes, IAuthData>({
      query: (formData) => ({
        url: '/login/',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['user'],
      transformResponse: (res: IAuthRes): IAuthRes => {
        window.localStorage.setItem('token', res?.token || '')
        return res
      },
    }),
    POST_authLogout: builder.mutation<IAuthRes, void>({
      query: () => ({
        url: '/logout/',
        method: 'POST',
      }),
      invalidatesTags: ['user'],
    }),
    POST_requestResetPassword: builder.mutation<any, {email: string}>({
      query: (formData) => ({
        url: '/password_reset/',
        method: 'POST',
        body: formData,
      }),
    }),
    POST_validateRestPasswordToken: builder.mutation<any, {token: string}>({
      query: (formData) => ({
        url: '/password_reset/validate_token/',
        method: 'POST',
        body: formData,
      }),
    }),
    POST_resetPassword: builder.mutation<any, {password: string, token: string}>({
      query: (formData) => ({
        url: '/password_reset/confirm/',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['user'],
      transformResponse: (res: IAuthRes): IAuthRes => {
        if (res?.token) window.localStorage.setItem('token', res.token)
        return res
      },
    }),
  }),
})

export const { 
  usePOST_authLoginMutation, 
  usePOST_authLogoutMutation, 
  usePOST_requestResetPasswordMutation, 
  usePOST_resetPasswordMutation, 
  usePOST_validateRestPasswordTokenMutation,
} = authAPI
